import React from 'react';
import LeftArrowIcon from '../../assets/icons/ArrowLeft.svg';
import RightArrowIcon from '../../assets/icons/Arrowright.svg';
import { Grid, makeStyles } from '@material-ui/core';

import KenButton from '../../components/KenButton';
import { Link, useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 32,
    [theme.breakpoints.down('xs')]: {
      margin: 12,
    },
  },
}));

export default function StepperFooter(props) {
  const classes = useStyles();
  const {
    stepperHandleBack,
    stepperActiveStep,
    stepperSteps = [],
    handleSubmit,
    stepsCount,
  } = props;

  const totalSteps = stepsCount || stepperSteps.length;
  return (
    <div className={classes.root}>
      <Grid container justify='space-between'>
        <Grid item>
          <Link
            to={{ pathname: '/applications', state: useLocation().state }}
            className='link-plain'
          >
            <KenButton variant='secondary' color='secondary'>
              Save Draft
            </KenButton>
          </Link>
        </Grid>
        <Grid item>
          <KenButton
            variant='secondary'
            icon={stepperActiveStep === 0 ? null : LeftArrowIcon}
            style={{ marginRight: 8 }}
            onClick={stepperHandleBack}
            disabled={stepperActiveStep === 0}
          >
            Previous
          </KenButton>
          <KenButton
            variant='primary'
            // TODO: validate form and check validity and submit
            onClick={handleSubmit}
            endIcon={<img src={RightArrowIcon} alt='' />}
          >
            {stepperActiveStep === totalSteps - 1 ? 'Submit' : 'Next'}
          </KenButton>
        </Grid>
      </Grid>
    </div>
  );
}
